export const modules = ['Driver', 'Fairway', 'Hybrid', 'Utility', 'Iron', 'Wedge', 'Loft & Lie', 'Putter', 'Transfer Club', 'Ball, Shoe, Glove', 'Player Info'] as const;

export type ModuleName = (typeof modules)[number];
